import { request } from '@/shared/api/request'

const CONTROLLER = '/contract/eContractTerm'
const TEENAGER = 'teenager'

export const terminate = (payload) => {
	return request({ url: 'contract/sendTerminationData', method: 'POST', data: payload })
}

export const terminateContract = (data) => {
	return request({ url: '/contract/terminate/xml', method: 'POST', data })
}

export const getTermStatusKdpFamilyForEmployee = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/statusKdpFamily`, method: 'GET', params })
}

export const sendTermKdpFamily = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/sendKdpFamily`, method: 'POST', params })
}

export const sendTermSmsConsent = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/sendSmsConsent`, method: 'POST', params })
}

export const verifyTermSmsConsent = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/verifySmsConsent`, method: 'POST', params })
}

export const getTermXmlForRole = (params, payload) => {
	return request({ url: `${CONTROLLER}/${payload.role}/xml`, method: 'GET', params })
}

export const saveTermSign = (params, payload) => {
	return request({ url: `${CONTROLLER}/${payload.role}/saveSign`, method: 'POST', data: params })
}
